import { render, staticRenderFns } from "./ProductInstructionForm.vue?vue&type=template&id=b5a3d11e&"
import script from "./ProductInstructionForm.vue?vue&type=script&lang=js&"
export * from "./ProductInstructionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports